import type { StoreApi } from 'zustand'
import type { createAuthActions } from '../domain/actions'
import type { InvisibleRecaptchaHandle } from '@/scopes/common/components/InvisibleRecaptcha/InvisibleRecaptcha'
import * as React from 'react'
import { AuthStore } from '@/scopes/auth/domain/types'

interface AuthDependencies {
  actions?: ReturnType<typeof createAuthActions>
  store?: StoreApi<AuthStore>
  recaptcha?: React.RefObject<InvisibleRecaptchaHandle | null>
}

const defaultDependencies: AuthDependencies = {}

const AuthDependenciesContext = React.createContext<AuthDependencies>(defaultDependencies)

export function AuthDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: AuthDependencies }>) {
  return (
    <AuthDependenciesContext value={dependencies}>
      {children}
    </AuthDependenciesContext>
  )
}

export function useAuthDependencies() {
  return React.use(AuthDependenciesContext)
}

export function useAuthActions() {
  const { actions } = useAuthDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}

export function useAuthRecaptcha() {
  const { recaptcha } = useAuthDependencies()
  if (!recaptcha) {
    throw new Error('recaptcha not provided')
  }
  return recaptcha
}
